import { render } from "./SelecionarValorCampoPersonalizado.vue?vue&type=template&id=193a05a2&ts=true"
import script from "./SelecionarValorCampoPersonalizado.vue?vue&type=script&lang=ts"
export * from "./SelecionarValorCampoPersonalizado.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__